<template>
<!-- TODO:有点击bug -->
    <div class="news-header">
       <div class="news-main flex-align-between">
            <ul class="nav-left flex-align">
                <li><a href="" target="_blank" rel="noopener noreferrer">银川市教育局</a></li>
                <li><a href="" target="_blank" rel="noopener noreferrer">双优云桥</a></li>
                <li><a href="" target="_blank" rel="noopener noreferrer">新闻网</a></li>
            </ul>
            <ul class="nav-right flex-align">
                <li v-for="(nav, index) in navs" 
                    :key="index" 
                    :class="{active:isActive === nav.id}"
                    @mouseenter="mouseEnter(nav.id)"
                    @mouseleave="mouseLeave()"
                    @click="gotoPage(index,nav)">
                    <!-- <router-link :to="nav.href" >{{nav.name}}</router-link> -->
                   {{nav.name}}
                </li>
                <!-- <li><router-link to="/home">返回主页</router-link></li>
                <li><router-link to="/home">返回主页</router-link></li> -->
                <li @click="goBackHome()">返回主页</li>
            </ul>
       </div>
    </div>
</template>

<script>
export default {
    props: {
        page: {
            type:String,
            // default:'新闻首页',
        }
    },
    data() {
        return {
            isActive:'',
            currentPage:'',
            timer:null,
            navs:[{
                id:0,
                name:'新闻首页',
                href:'/news'
            },{
                id:1,
                name:'头条新闻',
                href:'/news/headlines'
            },{
                id:2,
                name:'专题新闻',
                href:'/news/topic'
            },{
                id:3,
                name:'综合新闻',
                href:'/news/composite'
            },{
                id:4,
                name:'优秀学校',
                href:'/news/school'
            },{
                id:5,
                name:'优秀学员',
                href:'/news/student'
            },{
                id:6,
                name:'优秀课程',
                href:'/news/course'
            },
            ]
        }
    },
    watch:{
        $route(to,from) {
            // console.log(to);
            for(let i = 0;i<this.navs.length;i++) {
                 if(to.path === this.navs[i].href) {
                     this.isActive = this.navs[i].id;
                 }
            }
            sessionStorage.pageNumber = this.isActive
        },
    },
    methods: {
        goBackHome(){
            sessionStorage.removeItem('pageNumber');
            this.$router.push('/home');
        },
        gotoPage(index,nav){
            sessionStorage.pageNumber = nav.id
            this.$nextTick(function(){
                this.$router.push(nav.href)
            })
        },
         //   鼠标移入
         mouseEnter(id) {
            this.isActive = id;
         },
        //鼠标移除
         mouseLeave(name) {
             this.isActive = Number(sessionStorage.getItem('pageNumber'));
            // console.log(this.isActive)
         },
    },
    activated(){
        this.isActive = Number(sessionStorage.getItem('pageNumber'));
    },
    mounted: function() {
        this.isActive = Number(sessionStorage.getItem('pageNumber'));
    },
    deactivated(){
        
    }
}
</script>

<style lang="less" scoped>
    .news-header {
        height: 84px;
        font-size: 16px;
        background-color: #1c4b90;
    }

    .news-main {
        box-sizing: border-box;
        margin: 0 auto;
        padding: 20px 28px 0 33px;
        width: 1200px;
    }

    .nav-left {
        li {
            margin-right: 19px;
            
            &:first-child {
                margin-right: 29px;
            }

            &:last-child a{
                border-left: 1px solid #fff;
                padding-left:18px;
            }
        }
        
    }

    .nav-right {
        li {
            padding: 0 19px;
            line-height: 64px;

            color: #fff;
            background-color: #1c4b90;
            
            cursor: pointer;
            user-select: none; 
            &:last-child {
                padding: 0 0 0 19px;
                
                // a {   
                    display: block; 
                    font-size: 12px;
                    color: #3cf;
                // }  
            }
        }

        .active{
            color: #1c4b90;
            background-color: #fff;
        }
    }

    a {
        line-height: 64px;
        color: #fff;
    }
</style>